import React from 'react'
import { Col, Row, Select, Spin, theme } from 'antd'
import { useEntitySearch } from '../hooks'
import AgiliteSkeleton from '../../../../reusable-components/AgiliteSkeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faUserMd, faBuilding, faSearch } from '@fortawesome/free-solid-svg-icons'

/**
 * Component for rendering entity selection field (Patient, Practitioner, Clinic)
 */
const EntitySelect = ({ type, onSelect, initialValue }) => {
  const { searchLoading, searchData, handleSearch, resetSearch } = useEntitySearch(type)
  const { token } = theme.useToken()

  // Get appropriate icon based on entity type
  const getEntityIcon = () => {
    switch (type) {
      case 'Patient':
        return faUser
      case 'Practitioner':
        return faUserMd
      case 'Clinic':
        return faBuilding
      default:
        return faSearch
    }
  }

  // Get appropriate placeholder based on entity type
  const getPlaceholder = () => {
    if (initialValue) return initialValue

    switch (type) {
      case 'Patient':
        return 'Search for patient by name or ID'
      case 'Practitioner':
        return 'Search for practitioner by name'
      case 'Clinic':
        return 'Search for clinic by name'
      default:
        return `Search for ${type}`
    }
  }

  return (
    <Select
      className='entity-select'
      style={{ width: '100%' }}
      showSearch
      allowClear
      placeholder={getPlaceholder()}
      onSearch={(value) => handleSearch(value, type)}
      filterOption={false}
      onBlur={resetSearch}
      onChange={(value, option) => {
        if (option && onSelect) {
          onSelect(JSON.parse(option.data), type)
        }
      }}
      suffixIcon={<FontAwesomeIcon icon={getEntityIcon()} style={{ color: token.colorPrimary }} />}
      notFoundContent={
        searchLoading ? (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <Spin size='small' />
            <div style={{ marginTop: '8px', fontSize: '12px', color: token.colorTextSecondary }}>Searching...</div>
          </div>
        ) : (
          <Row style={{ padding: '12px' }}>
            <Col span={24}>
              <p style={{ textAlign: 'center', margin: '0 0 8px 0', color: token.colorTextSecondary }}>
                No {type} found
              </p>
              <div
                style={{
                  textAlign: 'center',
                  padding: '8px',
                  background: 'rgba(24, 144, 255, 0.05)',
                  borderRadius: '4px',
                  fontSize: '13px'
                }}
              >
                <FontAwesomeIcon icon={faSearch} style={{ marginRight: '8px', color: token.colorPrimary }} />
                Type a {type} name to search
              </div>
            </Col>
          </Row>
        )
      }
      options={searchData.map((item) => ({
        key: item._id,
        label:
          type === 'Clinic' ? item.name : `${item.firstName} ${item.lastName} ${item.idNo ? `(${item.idNo})` : ''}`,
        value: item._id,
        data: JSON.stringify(item)
      }))}
      dropdownStyle={{
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)'
      }}
    />
  )
}

export default EntitySelect
